const Q = require(`q`);
const _ = require(`underscore`);
const __request = require(`./__request/__request_contentType_json`);

// 火车票订单列表接口文档地址：http://192.168.0.13:9900/doc.html#/trains/buyer-order-controller/getBuyerOrderListUsingPOST
const trains_buyerOrder_getBuyerOrderList = (pParameter) => {
  if (!pParameter) pParameter = {};

  const p = {
    method: 'post',
    urlSuffix: '/trains/buyerOrder/getBuyerOrderList',
    data: pParameter,
  };
  return Q.when()
    .then(function () {
      return __request(p);
    })
    .then(function (data) {
      return Q.resolve(data);
    })
    .catch(function (ex) {
      console.error(ex);
      if (ex) {
        if (ex.stack) {
          console.error(ex.stack);
        }
      }
      return Q.reject(ex);
    })
    ;
};
module.exports = trains_buyerOrder_getBuyerOrderList;
